import { StepperStateToken } from "@app/utils";
import ROUTE from "./routes";
import { PrivateStackParamList } from "./types";


export type CreditApplicationStepState =
  | "NOT_STARTED"
  | "IN_PROGRESS"
  | "FAILED"
  | "COMPLETED"
  | "PENDING_CALLBACK"
  | "PENDING_VERIFICATION"
  | "PENDING_MANUAL_VERIFICATION"
  | "PENDING_LENDER_VERIFICATION"
  | "SKIPPED";

export type CreditApplicationStatus = {
  [stepName: string]: CreditApplicationStepState;
};

type GetNextRouteOptions = {
  isFetchFirstTime?: boolean;
};

export const getNextRoute = (
  stepId: string,
  applicationState: any,
  stepStatusMap: CreditApplicationStatus,
  enabledRTA?: string,
  pageEntry?: string,
  options?: GetNextRouteOptions
): keyof PrivateStackParamList => {
  console.log('getNextRoute called with stepId', stepId, stepStatusMap, pageEntry);
  const { isFetchFirstTime = false } = options || {};

  if (
    pageEntry === "HOME" &&
    [
      'KYC_DOCUMENTS', 'KYC_PHOTO_VERIFICATION', 'BANK_ACCOUNT_VERIFICATION',
      'KYC_ADDITIONAL_DETAILS', 'KYC_SUMMARY', 'DIGIO_MANDATE_SIGN',
      'TATA_MANDATE', 'SIGN_DESK_ESIGN', 'LOAN_CONTRACT', 'ASSET_PLEDGE'
    ].includes(stepId)
  ) {
    return ROUTE.KYC_STEPPER;
  }

  switch (stepId) {
    case ROUTE.EMAIL_VERIFICATION:
      return ROUTE.EMAIL_VERIFICATION;
    case 'KYC_ADDITIONAL_DETAILS':
      return ROUTE.KYC_ADDITIONAL_DETAILS;
    case 'SIGN_DESK_ESIGN':
      return ROUTE.SIGN_DESK_ESIGN;
    case 'TATA_MANDATE':
      return ROUTE.DIGIO_MANDATE_SIGN;
    case 'DIGIO_MANDATE_SIGN':
      return ROUTE.DIGIO_MANDATE_SIGN;
    case 'ASSET_PLEDGE':
      return ROUTE.ASSET_PLEDGE;
    case 'LOAN_CONTRACT':
      return ROUTE.DSP_KFS;
    case 'CREDIT_APPROVAL':
      return ROUTE.CREDIT_LOADING;
    case 'BANK_ACCOUNT_VERIFICATION':
      if (stepStatusMap[stepId] === 'PENDING_VERIFICATION') {
        return ROUTE.NAME_MISMATCH;
      } else {
        return ROUTE.BANK_ACCOUNT_VERIFICATION;
      }
    case "KYC_SUMMARY":
      return ROUTE.KYC_SUMMARY;
    case "KYC_DOCUMENTS":
      return ROUTE.KYC_DOCUMENTS;
    case "KYC_PHOTO_VERIFICATION":
      return ROUTE.KYC_PHOTO_VERIFICATION;
    case 'MF_PLEDGE_PORTFOLIO':
      if (enabledRTA === "MfCentralFlow") {
        return ROUTE.MFC_FETCH_ANCHOR;
      }
      if (isFetchFirstTime) {
        return ROUTE.CHECKING_LIMIT;
      } else if (stepStatusMap.MF_PLEDGE_PORTFOLIO === StepperStateToken.IN_PROGRESS) {
        return ROUTE.PLEDGE_CONFIRMATION;
      } else {
        return ROUTE.MF_PLEDGE_PORTFOLIO;
      }
    case "CHECKING_LIMIT":
      return ROUTE.CHECKING_LIMIT;
    case "PLEDGE_CONFIRMATION":
      return ROUTE.PLEDGE_CONFIRMATION;
    case "PORTFOLIO_FROM_RTA":
      return ROUTE.PORTFOLIO_FROM_RTA;
    case "SET_CREDIT_LIMIT":
      return ROUTE.SET_CREDIT_LIMIT;
    case "PORTFOLIO":
      return ROUTE.PORTFOLIO;
    case "MF_FETCH_PORTFOLIO":
      return ROUTE.MF_FETCH_PORTFOLIO;
    case "CHECK_CUSTOMER_ELIGIBILITY":
      return ROUTE.CHECK_CUSTOMER_ELIGIBILITY;
    case "CIBIL_CHECK_LOADING_SCREEN":
      return ROUTE.CIBIL_CHECK_LOADING_SCREEN;
    case "CIBIL_CHECK":
      return ROUTE.CIBIL_CHECK_LOADING_SCREEN;
    default:
      return stepId as keyof PrivateStackParamList; // TypeScript will warn unless you handle `never`
  }
};